function undefinedToNull(data) {
  if (data === undefined || data === null) {
    return null;
  } else if (Array.isArray(data)) {
    // remove null in array
    return data.filter(value => value != null);
  } else if (typeof data === 'object') {
    const obj = Object.keys(data).reduce((acc, key) => ({
      ...acc,
      [key]: undefinedToNull(data[key]),
    }), {});
    // use null to replace empty object
    const isPresent = Object.values(obj).some(value => value !== null);
    return isPresent ? obj : null;
  }
  return data;
}

export default undefinedToNull;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/undefinedToNull.js